import type { SVGProps } from 'react';
const SvgContentStatistic = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="-0.75 -0.75 20 20" {...props}>
    <desc>{'Content Statistic Streamline Icon: https://streamlinehq.com'}</desc>
    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}>
      <path d="M1.321 2.643v13.214c0 .73.592 1.322 1.322 1.322h13.214c.73 0 1.322-.592 1.322-1.322V2.643c0-.73-.592-1.322-1.322-1.322H2.643c-.73 0-1.322.592-1.322 1.322M4.625 4.625h2.643M4.625 7.598H9.25" />
      <path d="m13.875 9.25-3.304 4.625-3.303-2.643-2.643 2.643" />
    </g>
  </svg>
);
export default SvgContentStatistic;
